module.exports = "/shifts/directives/modal-shift-form-80240f.html";